<template>
  <section id="login">
    <img class="login-logo" src="../assets/images/mango-icon.png">
    <div class="container">
      <h1>Logga in i Mango</h1>
      <p v-if="$root.notification != ''">{{ $root.notification }}</p>
      <div class="form-field">
        <label for="username">E-postadress</label>
        <input type="text" name="username" v-model="user.username" placeholder="Användarnamn" value="">
      </div>
      <div class="form-field">
        <label for="password">Lösenord</label>
        <input type="password" name="password" v-model="user.password" placeholder="Lösenord" value="" v-on:keyup.enter="sendLoginData()">
      </div>
      <div class="form-field">
        <button class="primary solid" @click="sendLoginData()">Logga in</button>
        <router-link class="button info" to="/register">Skapa konto</router-link>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  props: {},
  data: function(){
    return {
      user: {
        username: '',
        password: '',
        token: ''
      },
      api_url: this.$parent.api_url
    }
  },
  methods: {
    sendLoginData() {
      let self = this;
      let url = self.api_url + "/login";
      axios
        .post(
          url,
          {
            email: self.user.username,
            password: self.user.password
          },
          {
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(function(response) {
          if( response.data.error ){
            self.$root.notification = 'Användarnamnet eller lösenordet är felaktigt, försök igen.';
            self.user.password = '';
            return;
          }
          
          self.$root.$emit('storeToken', response.data.data.api_token);
          self.$root.$emit('loadRooms');
          self.$root.$router.push('rooms');
          self.$root.notification = '';
        })
        .catch(function(error) {
        });
    },
  }
}
</script>

<style lang="scss">
  @import "../assets/css/_mixins.scss";
  @import "../assets/css/_variables.scss";
  @import '../assets/css/login.scss';
</style>
